var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCastleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.00001V4.48064C5 4.17686 5.13809 3.88954 5.3753 3.69977L6.8753 2.49977C7.24052 2.2076 7.75948 2.2076 8.12469 2.49977L9.62469 3.69977C9.86191 3.88954 10 4.17686 10 4.48064V7.00001H14V4.48064C14 4.17686 14.1381 3.88954 14.3753 3.69977L15.8753 2.49977C16.2405 2.2076 16.7595 2.2076 17.1247 2.49977L18.6247 3.69977C18.8619 3.88954 19 4.17686 19 4.48064V7.00001H20C20.5523 7.00001 21 7.44773 21 8.00001V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V8.00001C3 7.44773 3.44772 7.00001 4 7.00001H5ZM12 15C10.3431 15 9 16.3431 9 18V22H15V18C15 16.3431 13.6569 15 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastleAlt);
export default __webpack_public_path__ + "static/media/castle-alt.532b912b75090f4a93eeb84a9e85b02a.svg";
export { ForwardRef as ReactComponent };